import mainApiClient from '../clients/mainApiClient';
import { API_ENDPOINTS } from '../endpoints';

function normalizeRateByAmountResponse(response) {
  const payload = response?.data ?? response;

  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    return payload;
  }

  return payload == null ? null : {
    amount: String(payload),
  };
}

export const exchangeRatesApi = {
  getAll() {
    return mainApiClient.get(API_ENDPOINTS.exchangeRates.getAll, {
      auth: true,
    });
  },

  calculateByAmount({
    currencyId,
    currency_id,
    newCurrencyId,
    new_currency_id,
    amount,
    direction = true,
  } = {}) {
    return mainApiClient.get(API_ENDPOINTS.exchangeRates.calculateByAmount, {
      auth: true,
      params: {
        currency_id: currencyId ?? currency_id,
        new_currency_id: newCurrencyId ?? new_currency_id,
        amount,
        direction,
      },
    }).then(normalizeRateByAmountResponse);
  },
};
